import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getActionList = store => store[NAME].actionList;
export const getAccessList = store => store[NAME].accessList;
export const getPollList = store => store[NAME].pollList;
export const getConsentList = store => store[NAME].consentList;